"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _UIBreadcrumbs = _interopRequireDefault(require("../nav/UIBreadcrumbs"));

var UIBackButton = (0, _createReactClass.default)({
  displayName: 'UIBackButton',
  propTypes: {
    children: _propTypes.default.element.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      role: 'navigation'
    };
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className;
    return (0, _classnames.default)('private-back-button', className);
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        role = _this$props.role,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "children", "role"]);
    return _react.default.createElement(_UIBreadcrumbs.default, Object.assign({}, rest, {
      className: this.getClassName({
        className: className
      }),
      role: role
    }), children);
  }
});
var _default = UIBackButton;
exports.default = _default;
module.exports = exports.default;